/* eslint-disable import/no-extraneous-dependencies */
import React from 'react';
import PropTypes from 'prop-types';
import { Formik } from 'formik';
import {
  Modal,
  Button,
  Box,
  CircularProgress,
  TextField,
  Card,
  CardContent,
  CardActions,
  CardHeader,
  IconButton
} from '@mui/material';
import { Close } from '@mui/icons-material';
import { useDispatch } from 'react-redux';
import { ValidateWriteoffPaymentReason } from '../../assets/validation';
import PaymentAction from '../../store/actions/PaymentAction';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '500px !important',
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  pt: 2,
  px: 4,
  pb: 3
};

function ReasonModal({ open, data, itemId, onCloseModal, onCloseReasonModal }) {
  const dispatch = useDispatch();
  return (
    <Modal
      className="cmn__form__modal"
      open={open}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <Formik
          initialValues={{
            reason: ''
          }}
          enableReinitialize
          validationSchema={ValidateWriteoffPaymentReason}
          onSubmit={(values, { setErrors, setSubmitting }) => {
            const newValues = { ...data, ...values };
            dispatch(
              PaymentAction.updateManualPayment(
                itemId,
                newValues,
                setErrors,
                setSubmitting,
                onCloseModal,
                onCloseReasonModal
              )
            );
          }}
        >
          {({
            errors,
            touched,
            values,
            handleChange,
            handleBlur,
            handleSubmit,
            handleReset,
            isSubmitting,
            setFieldValue
          }) => (
            <form onSubmit={handleSubmit}>
              <Card>
                <CardHeader
                  title="Reason"
                  action={
                    <IconButton
                      aria-label="settings"
                      onClick={() => {
                        onCloseReasonModal();
                      }}
                    >
                      <Close />
                    </IconButton>
                  }
                />
                <CardContent>
                  <TextField
                    fullWidth
                    id="rea"
                    name="reason"
                    label="Reason"
                    placeholder="Enter Reason"
                    multiline
                    rows={3}
                    variant="outlined"
                    margin="normal"
                    value={values.reason}
                    onChange={(e) => {
                      handleChange(e);
                    }}
                    onBlur={(e) => {
                      handleBlur(e);
                      const val = (e.target.value || '').replace(/\s+/gi, ' ');
                      setFieldValue(e.target.name, val.trim());
                    }}
                    error={touched.reason && Boolean(errors.reason)}
                    helperText={touched.reason && errors.reason}
                    required={false}
                    InputLabelProps={{ required: true }}
                  />
                </CardContent>
                <CardActions sx={{ justifyContent: 'center' }}>
                  <Button
                    type="submit"
                    className="save__btn"
                    variant="contained"
                    color="secondary"
                    // fullWidth
                    disabled={isSubmitting}
                    size="small"
                  >
                    {isSubmitting ? <CircularProgress size={20} /> : 'Submit'}
                  </Button>
                  <Button
                    type="button"
                    className="cancel__btn"
                    variant="contained"
                    color="info"
                    size="small"
                    onClick={() => {
                      handleReset();
                    }}
                  >
                    Clear
                  </Button>
                </CardActions>
              </Card>
            </form>
          )}
        </Formik>
      </Box>
    </Modal>
  );
}
ReasonModal.propTypes = {
  itemId: PropTypes.string.isRequired,
  data: PropTypes.string.isRequired,
  open: PropTypes.bool.isRequired,
  onCloseModal: PropTypes.func.isRequired,
  onCloseReasonModal: PropTypes.func.isRequired
};

export default ReasonModal;
